import { render, staticRenderFns } from "./PlpModifiedLog.vue?vue&type=template&id=fa34c0c2"
import script from "./PlpModifiedLog.vue?vue&type=script&lang=js"
export * from "./PlpModifiedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports